const FETCH_PUNISHMENT_LIST_REQUEST = "FETCH_PUNISHMENT_LIST_REQUEST";
const FETCH_PUNISHMENT_LIST_SUCCESS = "FETCH_PUNISHMENT_LIST_SUCCESS";
const FETCH_PUNISHMENT_LIST_FAILURE = "FETCH_PUNISHMENT_LIST_FAILURE";

export default {
  FETCH_PUNISHMENT_LIST_REQUEST,
  FETCH_PUNISHMENT_LIST_SUCCESS,
  FETCH_PUNISHMENT_LIST_FAILURE,
};
